import { AllDataBreeding } from "../../../api/breeding";
import { BreedingCard } from "./BreedingCard";

type BreedingsTableContentProps = {
  breedings: AllDataBreeding[];
  windowHeight: number;
  onSelectBreeding: (breeding: AllDataBreeding) => void;
};

export const BreedingsTableContent = ({
  breedings,
  windowHeight,
  onSelectBreeding,
}: BreedingsTableContentProps) => {
  return (
    <div
      className="bg-grey-light shadow p-4 rounded-lg overflow-y-auto"
      style={{ maxHeight: windowHeight - 310 }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {breedings.map((breeding) => (
          <BreedingCard
            key={breeding.breeding.id}
            data={breeding}
            onSelect={() => onSelectBreeding(breeding)}
          />
        ))}
      </div>
    </div>
  );
};
